<template>
  <div class="home-footer">
    <div class="home-copyright-container">
      <svg viewBox="0 0 1024 1024" class="home-icon26">
        <path
          d="M512 854q140 0 241-101t101-241-101-241-241-101-241 101-101 241 101 241 241 101zM512 86q176 0 301 125t125 301-125 301-301 125-301-125-125-301 125-301 301-125zM506 390q-80 0-80 116v12q0 116 80 116 30 0 50-17t20-43h76q0 50-44 88-42 36-102 36-80 0-122-48t-42-132v-12q0-82 40-128 48-54 124-54 66 0 104 38 42 42 42 98h-76q0-14-6-26-10-20-14-24-20-20-50-20z"
        ></path>
      </svg>
      <span class="Anchor">Copyright Langglas, {{ getFullYear() }}</span>
    </div>
  </div>
</template>

<script lang="js">
export default {
  name: "Footer",
    methods: {
        getFullYear() {
            return new Date().getFullYear();
        },
    }
  }
</script>

<style scoped>
.home-footer {
  width: 100%;
  display: flex;
  max-width: var(--dl-size-size-maxcontent);
  padding-top: var(--dl-space-space-tripleunit);
  padding-left: var(--dl-space-space-tripleunit);
  padding-right: var(--dl-space-space-tripleunit);
  flex-direction: row;
  padding-bottom: var(--dl-space-space-tripleunit);
  justify-content: center;
}

.home-copyright-container {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
}

.home-icon26 {
  width: 24px;
  height: 24px;
  margin-right: var(--dl-space-space-doubleunit);
}
</style>
